import React from "react";

const CrossIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="cross_icon"
      data-name="cross"
      {...props}
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7946 4.22925L7.96598 7.05725L5.13798 4.22925L4.19531 5.17191L7.02331 7.99991L4.19531 10.8279L5.13798 11.7706L7.96598 8.94258L10.7946 11.7706L11.7373 10.8279L8.90931 7.99991L11.7373 5.17191L10.7946 4.22925Z"
        fill={props.fill || "#3A8AB9"}
      />
    </svg>
  );
};

export default CrossIcon;
